export const DEFAULT_GAS_PRICE_GWEI = 40;
export const MAX_GAS_PRICE_GWEI = 400;
